module.exports = __webpack_public_path__ + "static/media/tick_active69975496.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/images/tick_active.svg
// module id = 1456
// module chunks = 0